import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const InformationRequiredModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "InformationRequiredModalContainer" */
      './InformationRequiredModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
